<template>
  <TableList
    v-rect-loading="loading"
    class="job-location-management-page"
    row-key="id"
    :title="$t(`${i18nPrefix}.title`)"
    :tableColumns="tableColumns"
    :listData="locationList"
    :pagination="pagination"
    :defaultSort="{ prop: 'review_status', order: 'descending'}"
    @action="handleEditLocation"
    @sort-change="handleSortChange"
    @pagination-change="handlePaginationChange"
  >
    <template #filter>
      <div class="header-left">
        <span class="text">{{ $t(`${i18nPrefix}.label.companyName`) }}</span>
        <span class="company-select">
          <el-select v-model="selectedCompany" filterable clearable @change="handleCompanySelect">
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.i18nName"
              :style="{ paddingLeft: item.level * 15 + 'px' }"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </span>
      </div>
      <div class="header-left">
        <span class="city-select">
          <el-select
            v-model="selectedCity"
            filterable
            clearable
            :placeholder="$t(`${i18nPrefix}.placeholder.city`)"
            @change="handleCitySelect"
          >
            <el-option
              v-for="item in locationCityList"
              :key="item.id"
              :label="item.i18nName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </span>
      </div>
      <div class="header-left">
        <span class="status-select">
          <el-select
            v-model="selectedStatus"
            clearable
            :placeholder="$t(`${i18nPrefix}.placeholder.status`)"
            @change="handleStatusSelect"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </span>
      </div>
    </template>
    <template #btn>
      <div class="header-search">
        <el-input
          v-model="keywords"
          class="search-input"
          clearable
          :placeholder="$t(`${i18nPrefix}.placeholder.search`)"
          @input="handleKeywordsChange"
        >
        </el-input>
      </div>
      <div class="btn-group">
        <el-button class="add-btn" @click="handelAddLocation">{{ $t(`${i18nPrefix}.btn.addLocation`) }}</el-button>
        <el-button class="upload-btn" @click="handelBatchUpload">{{ $t(`${i18nPrefix}.btn.batchUpload`) }}</el-button>
      </div>
    </template>
    <template #address="{data, row}">
      <el-popover trigger="hover" placement="right-start" :visible-arrow="false" @show="handleShowMap(row)">
        <template #reference>
          <span>{{ data }}</span>
        </template>
        <div v-if="showMapId === row.id" ref="mapPop"></div>
      </el-popover>
    </template>
    <template #status="{ data, row }">
      <el-switch :value="data" @change="onEnabledChange($event, row)"></el-switch>
    </template>
    <template #page-bottom>
      <LocationEditorDialog
        :show.sync="locationDialog.show"
        :value="locationDialog.location"
        :titleI18nKey="locationDialog.title"
        :dialogLoading="locationDialog.loading"
        @change="handleEditLocationChanged"
      />
      <DialogWrapper
        :loading="batchUPloadDialog.loading"
        :show.sync="batchUPloadDialog.show"
        @cancel="handleClose"
        @save="uploadLocation"
      >
        <div>
          <label>1. </label>
          <el-button type="text" class="template-link" href="" @click="downloadTemplate">{{ $t(`${i18nPrefix}.btn.downloadTemplate`) }}</el-button>
        </div>
        <div class="upload-input">
          <div class="file-type-tip"><label>2. {{ $t(`${i18nPrefix}.label.excelInput`) }}</label></div>
          <el-input v-model="file.name" readonly="readonly" type="text" id="show_file" class="select-file-input" />
          <el-button class="select-file" size="small" @click="selectFile">{{ $t(`${i18nPrefix}.btn.selectFile`) }}</el-button>
        </div>
        <div>
          <span v-show="showUploadTip" class="file-error-tip">{{ $t(`${i18nPrefix}.message.uploadTip`) }}</span>
          <input type="file" ref="uploadFile" class="upload-file" @change="fileChange" />
        </div>
      </DialogWrapper>
      <DialogWrapper
        class="location-delete-dialog"
        :show.sync="locationDisableDialog.show"
        :title="locationDisableDialog.title"
        :loading="locationDisableDialog.loading"
        @save="confirmDisableLocation"
      >
      </DialogWrapper>
      <div ref="map" class="map-preview" :id="map.container"></div>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import LocationEditorDialog from '@/components/job/editor/locationEditorDialog.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { addI18nProperty } from '@/i18n'
import { mapActions } from 'vuex'
import { getAMap } from '@/plugins/amap'

export default {
  components: {
    TableList,
    DialogWrapper,
    LocationEditorDialog
  },
  props: {

  },
  data () {
    return {
      i18nPrefix: 'admin.company.jobLocationManagement',
      loading: false,
      locationList: [],
      companyList: null,
      selectedCompany: null,
      currentCompanyId: null,
      rootCompanyId: null,
      selectedCity: null,
      locationCityList: null,
      selectedStatus: null,
      editLocationId: null,
      order: '-review_status',
      fileList: [],
      file: {
        lastModified: null,
        lastModifiedDate: null,
        name: '',
        size: null,
        type: '',
        webkitRelativePath: ''
      },
      fileType: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'application/wps-office.xlsx', 'application/wps-office.xls'],
      showUploadTip: false,
      keywords: null,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      locationDialog: {
        loading: false,
        location: null,
        show: false,
        title: 'admin.company.jobLocationManagement.label.addLocation'
      },
      locationDisableDialog: {
        show: false,
        title: null,
        loading: false,
        row: null,
        newStatus: null
      },
      batchUPloadDialog: {
        show: false,
        loading: false
      },
      map: {
        container: 'mapPreview',
        hasInit: false,
        instance: null,
        geoCoder: null,
        toolbar: null,
        marker: null
      },
      showMapId: null,
      mapLoader: null,
      firstLoad: true
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.city`),
          dataKey: 'city.i18nName',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.region`),
          dataKey: 'region.i18nName',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.cbd`),
          dataKey: 'cbd.i18nName',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.address`),
          dataKey: 'address',
          slotName: 'address',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.status`),
          dataKey: 'review_status',
          slotName: 'status',
          sort: {
            enable: 'custom',
            orders: ['descending', 'ascending']
          }
        }
      ]
      return columns
    },
    statusList () {
      return [
        {
          label: this.$t(`${this.i18nPrefix}.label.active`),
          value: 1
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.inactive`),
          value: 0
        }
      ]
    },
    queryCompany () {
      return this.$route.query.company
    },
    mapEl () {
      return this.$refs.map
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    ...mapActions('company', [
      'getCompanyJobLocationList',
      'getCompanyChildrenTree',
      'createCompanyJobLocation',
      'uploadCompanyJobLocation',
      'updateCompanyJobLocation'
    ]),
    async loadCompanyList () {
      if (this.currentCompanyId) {
        return
      }
      this.loading = true
      try {
        const companyTreeResp = await this.getCompanyChildrenTree()
        const currentCompany = {
          id: companyTreeResp.self.id,
          name: companyTreeResp.self.name,
          cn_name: companyTreeResp.self.cn_name,
          level: companyTreeResp.self.level
        }
        this.currentCompanyId = currentCompany.id
        this.rootCompanyId = companyTreeResp.root?.id
        const companyList = []
        this.companyList = this.formatCompanyData(companyTreeResp, currentCompany, companyList)
        if (this.firstLoad && !this.queryCompany) {
          this.$router.push({ query: { company: this.currentCompanyId } })
        }
      } finally {
        this.firstLoad = false
        this.loading = false
      }
    },
    async loadLocationList (refresh) {
      this.loading = true
      if (refresh) {
        this.pagination.page = 1
      }
      try {
        const params = {
          job_location_manage: 1,
          company_id: this.selectedCompany,
          city: this.selectedCity,
          address: this.keywords,
          order: this.order,
          status: this.selectedStatus,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }
        const resp = await this.getCompanyJobLocationList(params)
        if (resp && resp.result) {
          this.locationList = _.map(resp.result, location => {
            this.addI18nName(location.city)
            this.addI18nName(location.city?.parent)
            this.addI18nName(location.region)
            this.addI18nName(location.cbd)
            return location
          })
          this.locationCityList = _.map(resp.city_list, city => {
            this.addI18nName(city)
            return city
          })
          this.pagination.total = resp.total
        }
      } finally {
        this.loading = false
      }
    },
    onEnabledChange (status, row) {
      if (!status) {
        const address = `${row.city.i18nName}${row.region ? `-${row.region.i18nName}` : ''}${row.cbd ? `-${row.cbd.i18nName}` : ''}${row.address ? `-${row.address}` : ''}`
        this.locationDisableDialog.newStatus = status
        this.locationDisableDialog.row = row
        this.locationDisableDialog.title = this.$t(`${this.i18nPrefix}.message.disableLocation`, { address: address })
        this.locationDisableDialog.show = true
      } else {
        this.updateLocationStatus(status, row)
      }
    },
    confirmDisableLocation () {
      const status = this.locationDisableDialog.newStatus
      const row = this.locationDisableDialog.row
      this.updateLocationStatus(status, row, true)
    },
    async updateLocationStatus (status, row, isDialog) {
      isDialog ? this.locationDisableDialog.loading = true : this.loading = true
      try {
        const data = {
          jobLocationId: row.id,
          data: {
            status: status,
            company_id: row.company_id
          }
        }
        const resp = await this.updateCompanyJobLocation(data)
        if (resp === 'success') {
          row.review_status = !row.review_status
          this.$message.success(this.$t('common.message.optionSuccess'))
        } else if (resp.only_location_jobs) {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.onlyLocationTip`, { locationIds: resp.only_location_jobs }))
        }
      } finally {
        this.loading = false
        this.locationDisableDialog.loading = false
        this.locationDisableDialog.show = false
      }
    },
    handelBatchUpload () {
      this.batchUPloadDialog.show = true
    },
    async uploadLocation () {
      if (!this.handleBeforeUpload(this.file)) {
        return
      }
      this.batchUPloadDialog.loading = true
      try {
        const data = {
          batch_upload_file: this.file
        }
        const resp = await this.uploadCompanyJobLocation(data)
        if (resp) {
          this.clearFile()
          this.batchUPloadDialog.show = false
          this.$router.push({
            path: '/v-admin/job-location/management/verify-upload',
            query: {
              ...this.$route.query,
              company: this.queryCompany || this.currentCompanyId,
              uploaded_info: resp
            }
          })
        } else {
          this.handleUploadError(resp, this.file)
        }
      } finally {
        this.batchUPloadDialog.loading = false
      }
    },
    downloadTemplate () {
      window.location.href = this.$DjangoStaticUrl('/templates/batch_upload_job_location_template.xls')
    },
    handleClose () {
      this.batchUPloadDialog.loading = false
      this.batchUPloadDialog.show = false
      this.clearFile()
    },
    selectFile () {
      this.clearFile()
      this.$refs.uploadFile.dispatchEvent(new MouseEvent('click'))
      this.showUploadTip = false
    },
    fileChange () {
      this.file = this.$refs.uploadFile.files[0]
      if (!this.file) {
        this.file = {
          lastModified: null,
          lastModifiedDate: null,
          name: '',
          size: null,
          type: '',
          webkitRelativePath: ''
        }
      }
    },
    handleBeforeUpload (file) {
      if (!this.fileType.includes(file.type)) {
        this.showUploadTip = true
        return false
      }
      return true
    },
    handleUploadError (resp, file) {
      this.$message.warning({
        message: this.$t(`${this.i18nPrefix}.message.uploadError`),
        duration: 2000
      })
    },
    clearFile () {
      this.$refs.uploadFile.value = ''
      this.file = {
        lastModified: null,
        lastModifiedDate: null,
        name: '',
        size: null,
        type: '',
        webkitRelativePath: ''
      }
    },
    handelAddLocation () {
      this.editLocationId = null
      this.locationDialog.location = null
      this.locationDialog.show = true
      this.locationDialog.title = `${this.i18nPrefix}.label.addLocation`
    },
    handleEditLocation (row) {
      this.editLocationId = row.id
      this.locationDialog.location = row
      this.locationDialog.show = true
      this.locationDialog.title = `${this.i18nPrefix}.label.editLocation`
    },
    async handleEditLocationChanged (location) {
      let resp
      const jobLocation = {
        city_id: location.city.id,
        region_id: location.region?.id,
        cbd_id: location.cbd?.id,
        address: location.address,
        lng: location.lng,
        lat: location.lat
      }
      this.locationDialog.loading = true
      try {
        if (this.editLocationId) {
          const data = {
            jobLocationId: this.editLocationId,
            data: {
              company_id: this.queryCompany || this.currentCompanyId,
              job_location: jobLocation
            }
          }
          resp = await this.updateCompanyJobLocation(data)
          if (resp === 'existed') {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.locationIsExisted`))
            return
          }
        } else {
          const data = {
            company_id: this.queryCompany || this.currentCompanyId,
            job_location_list: [jobLocation]
          }
          resp = await this.createCompanyJobLocation(data)
          if (resp && _.isEmpty(resp)) {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.locationIsExisted`))
            return
          }
        }
        if (resp) {
          this.$message.success(this.$t('common.message.optionSuccess'))
          this.loadLocationList(true)
          this.locationDialog.show = false
        }
      } finally {
        this.locationDialog.loading = false
      }
    },
    async loadAMap () {
      if (!this.mapLoader) {
        const plugins = ['AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.ToolBar']
        this.mapLoader = getAMap(plugins, '2.0', false)
      }
      return this.mapLoader
    },
    async initMap () {
      const AMap = await this.loadAMap()
      const markerIcon = new AMap.Icon({
        image: require('@/assets/amap/poi-marker-red.png'),
        imageSize: new AMap.Size(25, 34)
      })
      const marker = new AMap.Marker({
        icon: markerIcon,
        offset: new AMap.Pixel(-13, -30),
        draggable: true,
        cursor: 'move'
      })
      this.map.geoCoder = new AMap.Geocoder()
      this.map.toolbar = new AMap.ToolBar()
      this.map.marker = marker
      this.map.hasInit = true
      if (!this.map.instance) {
        const AMap = await this.loadAMap()
        const mapInstance = new AMap.Map(this.map.container, { zoom: 15 })
        mapInstance.addControl(this.map.toolbar)
        mapInstance.on('click', (event) => {
          const lngLat = event.lnglat
          this.setMapMarkerPosition(lngLat)
        })
        this.map.instance = mapInstance
      }
    },
    async handleShowMap (location) {
      this.showMapId = location.id
      await this.$nextTick()
      const mapPopEl = this.$refs.mapPop
      if (this.mapEl) {
        this.mapEl.style.top = '0'
        mapPopEl.appendChild(this.mapEl)
      }
      await this.renderMap(location)
    },
    async renderMap (location) {
      if (!this.map.instance) {
        await this.initMap()
      }
      this.setMapMarkerPosition([location.lng, location.lat])
    },
    handleHiddenMap () {
      this.showMapId = null
    },
    setMapMarkerPosition (lngLat) {
      const map = this.map
      const mapInstance = map.instance
      const marker = map.marker
      if (!marker.getMap()) {
        marker.setMap(mapInstance)
      }
      mapInstance.setCenter(lngLat)
      marker.setPosition(lngLat)
    },
    handleCompanySelect () {
      this.$router.push({ query: { company: this.selectedCompany } })
    },
    handleCitySelect () {
      this.loadLocationList(true)
    },
    handleStatusSelect () {
      this.loadLocationList(true)
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.handlerSearch, 1000)
      }
      this.keywordsSearchDebounce()
    },
    handlerSearch () {
      this.loadLocationList(true)
    },
    handlePaginationChange () {
      this.loadLocationList()
    },
    handleSortChange (prop, order) {
      this.order = `${order}${prop}`
      this.loadLocationList(true)
    },
    formatCompanyData (data, company, companyList) {
      addI18nProperty(company, 'i18nName', 'cn_name', 'name')
      companyList.push(company)
      const allChildren = data.children
      const children = allChildren[company.id]
      if (children && children.length > 0) {
        _.forEach(children, (child) => {
          this.formatCompanyData(data, child, companyList)
        })
      }
      return companyList
    },
    addI18nName (obj) {
      return addI18nProperty(obj, 'i18nName', 'cn_name', 'name')
    }
  },
  watch: {
    $route: {
      immediate: true,
      async handler () {
        if (!this.currentCompanyId) {
          await this.loadCompanyList()
        }
        let queryCompany = this.queryCompany
        if (queryCompany) {
          queryCompany = parseInt(queryCompany)
          if (this.selectedCompany !== queryCompany) {
            this.selectedCompany = queryCompany
          }
        }
        this.loadLocationList(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.job-location-management-page {

  .header-left {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;

    .text {
      margin-right: 10px;
      display: inline-block;
      vertical-align: middle;
    }

    .company-select {
      display: inline-block;
      vertical-align: middle;
    }

    .city-select {
      display: inline-block;
      vertical-align: middle;
      width: 150px;
    }

    .status-select {
      display: inline-block;
      vertical-align: middle;
      width: 150px;
    }
  }

  .header-search {
    vertical-align: middle;
    margin-bottom: 10px;
    margin-right: 24px;
  }

  .btn-group {
    margin-bottom: 10px;
  }

  .upload-input {
    display: flex;
    align-items: center;

    .select-file-input {
      flex: 1;
      margin-left: 10px;
    }
  }

  .upload-cancel {
    background-color: #aaa;
    color:#ffffff;
    width: 86px;
    margin-right: 30px;
    border-width: 0;
    font-weight: 700;
  }

  .upload-submit {
    width: 86px;
    background-color: #0096cc;
    color: #fff;
    border-width: 0;
    font-weight: 700;
  }

  .select-file {
    margin-left: 5px;
    background-color: #aaa;
    color: #ffffff;
    width: 86px;
    border-width: 0;
    font-weight: 700;
  }

  .submit-upload {
    width: 30%;
    margin-left: 15px;
  }

  .upload-file {
    display: none;
  }

  .file-error-tip {
    margin-left: 10px;
    color: red;
  }

  ::v-deep {
    .list-head {
      height: auto;
      flex-wrap: wrap;
      justify-content: flex-end;
      margin-bottom: 10px;

      .title {
        margin-bottom: 10px;
      }

      .btn-container {
        display: flex;
        margin-left: 10px;
      }
    }

    .el-dialog {
      width: 591px;
    }

    .el-dialog__body {
      padding: 30px 40px;
    }
  }
}

.map-preview {
  top: -9999px;
  width: 200px;
  height: 200px;
}
</style>
